import { useRef } from "react";
// Alert on page change (except first load)

import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Card,
  ConfigProvider,
  Flex,
  Avatar,
  Typography,
  Drawer,
  Button,
  Dropdown,
  Space,
  Tooltip,
  Breadcrumb,
} from "antd";
import {
  DownOutlined,
  MenuOutlined,
  CheckOutlined,
  UserOutlined,
  MessageOutlined,
  WhatsAppOutlined,
  MailOutlined,
  ApiOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { ReactComponent as Dashboard } from "../assets/Icons/dashboardNew.svg";
import { ReactComponent as TargetAchievement } from "../assets/Icons/targetAchievement.svg";
import { ReactComponent as Reports } from "../assets/Icons/reports.svg";
import { ReactComponent as Portfolio } from "../assets/Icons/portfolioIcon.svg";
import { ReactComponent as Permission } from "../assets/Icons/permissionIcon.svg";
import { ReactComponent as Traceability } from "../assets/Icons/tracebilityIcon.svg";
import { ReactComponent as AgencyDetail } from "../assets/Icons/agencyDetail.svg";
import { ReactComponent as Allocate } from "../assets/Icons/allocationIcon.svg";
import { ReactComponent as Upload } from "../assets/Icons/uploadIcon.svg";
import { ReactComponent as Analysis } from "../assets/Icons/analysisIcon.svg";
import { ReactComponent as SeparatorIcon } from "../assets/Icons/separatorIcon.svg";
import { ReactComponent as SummaryReportIcon } from "../assets/Icons/summary-report-svg.svg";
import logo from "../assets/Icons/sidebarlogo.svg";
import fullLogo from "../assets/Images/fulllogo_.png";
import { ReactComponent as CashIcon } from "../assets/Icons/cashicon.svg";
import "./PageLayout.scss";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/auth";
import { Toaster } from "react-hot-toast";
import Tabs from "../Reuseable/Tabs/Tabs";
import { setPriceFormat } from "../store/priceFormat";
import { clearQuery } from "../store/filters";
import { getUserType } from "../assets/helpers";
const { Header, Content, Sider } = Layout;
const { Text } = Typography;
const PageLayout = ({ children, title: propTitle }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [openKeys, setOpenKeys] = useState([]); // State for submenu open keys
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { format } = useSelector((state) => state.priceFormat);
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 640);
  const { pathname } = useLocation();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const firstLoadRef = useRef(true);
  useEffect(() => {
    if (firstLoadRef.current) {
      firstLoadRef.current = false;
      return;
    }
    // dispatch(clearQuery());
  }, [location.pathname]);

  const extraRoutes = () => {
    switch (getUserType(user)) {
      case "telecaller":
        return [
          {
            key: "/field-agent-allocation",
            icon: <Portfolio />,
            label: <Link to="/field-agent-allocation">Field Agent Allocations</Link>,
          },
          {
            key: "/telecaller-summary-report",
            icon: <SummaryReportIcon style={{width:'20px',height:'20px'}}/>,
            label: <Link to="/telecaller-summary-report">Summary Report</Link>,
          },
        ];
      default:
        return [];
    }
  }

  let menuItems = [
    {
      key: "/dashboard",
      icon: <Dashboard />,
      label: "Dashboard",

      children: [
        {
          key: "/dashboard",
          icon: "",
          label: <Link to="/dashboard">Dashboard</Link>,

        },
        getUserType(user) === "agency" && {
          key: "/bank-dashboard",
          icon: "",
          label: <Link to="/bank-dashboard">Bank Dashboard</Link>,
        },
      ].filter(Boolean),
    },
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/agency/user",
      icon: <AgencyDetail />,
      label: "AgencyDetail",
      children: [
        {
          key: "/agency/user",
          icon: "",
          label: <Link to="/agency/user">User</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/agency/product",
          icon: "",
          label: <Link to="/agency/product">Product</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/agency/area-codes",
          icon: "",
          label: <Link to="/agency/area-codes">Area Codes</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/permission",
          icon: "",
          label: <Link to="/permission">Permissions</Link>,
        },
      ].filter(Boolean),
    },
    getUserType(user) === 'agency' && {
      key: "/portfolio",
      icon: <Portfolio />,
      label: <Link to="/portfolio">Portfolio</Link>,
    },
    getUserType(user) === "agency" && {
      key: "/rules",
      icon: <Permission />,
      label: <Link to="/rules">Rules</Link>,
    },
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/allocation",
      icon: <Allocate />,
      label: "Allocation",
      children: [
        getUserType(user) === "agency" && {
          key: "/allocation/user-wise",
          icon: "",
          label: <Link to="/allocation/user-wise">Allocation user wise</Link>,
        },
        {
          key: "/allocation/cases",
          icon: "",
          label: <Link to="/allocation/cases">Cases</Link>,
        },
      ].filter(Boolean),
    },
    getUserType(user) === 'telecaller' && {
      key: "/allocation/cases",
      icon: <Permission />,
      label: 'Cases',
         children: [
          {
          key: "/allocation/cases",
          icon: "",
          label: <Link to="/allocation/cases">Cases</Link>,
        },
        {
          key: "/cases-feedback",
          icon: "",
          label: <Link to="/cases-feedback">Cases Feedback</Link>,
        }
      ],
    },
    ...extraRoutes(),
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/geo-tagging",
      icon: <Traceability />,
      label: <Link to="/geo-tagging">GEO Tagging</Link>,
    },
    // getUserType(user) === 'agency' && {
    //   key: "/target-achievement",
    //   icon: <TargetAchievement />,
    //   label: <Link to="/target-achievement">Target & Achievement</Link>,
    // },
    // getUserType(user) === 'agency' && {
    //   key: "/reports",
    //   icon: <Reports />,
    //   label: <Link to="/reports">Reports</Link>,
    // },
    // {
    //   key: "/upload",
    //   icon: <Upload />,
    //   label: <Link to="/upload">Upload</Link>,
    // },
    // getUserType(user) === 'agency' && {
    //   key: "/analysis/overview",
    //   icon: <Analysis />,
    //   label: "Analysis",
    //   children: [
    //     {
    //       key: "/analysis/overview",
    //       icon: "",
    //       label: <Link to="/analysis/overview">Overview</Link>,
    //     },
    //     {
    //       key: "/analysis/coverage",
    //       icon: "",
    //       label: <Link to="/analysis/coverage">Coverage</Link>,
    //     },
    //     {
    //       key: "/analysis/productivity",
    //       icon: "",
    //       label: <Link to="/analysis/productivity">Productivity</Link>,
    //     },
    //     {
    //       key: "/analysis/performance",
    //       icon: "",
    //       label: <Link to="/analysis/performance">Performance</Link>,
    //     },
    //   ],
    // },

    // getUserType(user) === 'agency' && {
    //   key: "/ai-collecteaze",
    //   icon: <Analysis />,
    //   label: (
    //     <a
    //       href="http://65.1.222.81:8502/"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Collecteaze AI
    //     </a>
    //   ),
    // },
    // getUserType(user) === 'agency' && {
    //   key: "/collecteaze-ai",
    //   icon: <Analysis />,
    //   label: <Link to="/collecteaze-ai">Collecteaze Chat AI </Link>,
    // },
    getUserType(user) === "agency" && {
      key: "/communication",
      icon: <ApiOutlined />,
      label: "Communication",
      children: [
        {
          key: "/communication/sms",
          icon: <MessageOutlined />,
          label: <Link to="/communication/sms">SMS</Link>,
        },
        {
          key: "/communication/whatsapp",
          icon: <WhatsAppOutlined />,
          label: <Link to="/communication/whatsapp">Whatsapp</Link>,
        },
        {
          key: "/communication/email",
          icon: <MailOutlined />,
          label: <Link to="/communication/email">Email</Link>,
        },
      ],
    },
    getUserType(user) === "telecaller" && {
      key: "telecaller/ptp-list",
      icon: <Permission />,
      label: "Cases",
      children: [
        {
          key: "/telecaller/ptp-list",
          icon: "",
          label: <Link to="/telecaller/ptp-list">PTP List</Link>,
        },
        {
          key: "/telecaller/callback-list",
          icon: "",
          label: <Link to="/telecaller/callback-list">Callback List</Link>,
        },
      ],
    },

    ["telecaller", "agency", "supervisor"].includes(getUserType(user)) && {
      key: "/attendance",
      icon: <CalendarOutlined />,
      label: <Link to="/attendance">Attendance</Link>,
    },

    getUserType(user) === "agency" && {
      key: "/script",
      icon: <Analysis />,
      label: <Link to="/script">Call Script </Link>,
    },
  ];

  // Determine the selected key and default open keys based on the current location
  const getSelectedAndOpenKeys = () => {
    const path = location.pathname;
    let selectedKey = "/";
    let openKey = [];

    // If path is root or empty, set dashboard as selected
    if (path === "/" || path === "") {
      return { selectedKey: "/dashboard", openKey: [] };
    }

    for (const item of menuItems) {
      if (item.key === path) {
        selectedKey = item.key;
        return { selectedKey, openKey };
      }

      if (item.children) {
        for (const child of item.children) {
          if (path === child.key || path.startsWith(child.key + "/")) {
            selectedKey = child.key;
            openKey = [item.key];
            return { selectedKey, openKey };
          }
        }

        // Match fallback: path is deeper than direct children
        if (path.startsWith(item.key + "/")) {
          selectedKey = item.key;
          openKey = [item.key];
          return { selectedKey, openKey };
        }
      } else if (path.startsWith(item.key + "/")) {
        selectedKey = item.key;
        return { selectedKey, openKey };
      }
    }

    // Fallback if no match found
    return { selectedKey: "/dashboard", openKey: [] };
  };

  const { selectedKey, openKey } = getSelectedAndOpenKeys();

  // useEffect(() => {
  //   // Initialize openKeys based on the current route
  //   setOpenKeys(openKey);
  // }, [location.pathname]);

  // Handle submenu open/close without interfering with navigation
  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };



  // Handle click on submenu title to open/close without navigating
  const handleSubMenuClick = (key) => {
    setDrawerOpen(false);
    const isOpen = openKeys.includes(key);
    if (isOpen) {
      setOpenKeys(openKeys.filter((k) => k !== key)); // Close submenu
    } else {
      setOpenKeys([...openKeys, key]); // Open submenu
    }
  };

  const titleMap = {
    "/": "Upload",
    "/analysis/overview": "Analysis",
    "/analysis/coverage": "Coverage",
    "/analysis/performance": "Performance",
  };
  const formatPriceKeys = [
    { label: "Absolute", value: "Absolute" },
    { label: "Crore", value: "Crore" },
    { label: "Lakh", value: "Lakh" },
  ];
  const handleLogout = () => {
    dispatch(logout());
    navigate("/sign-in");
  };
  const title = propTitle || titleMap[location.pathname] || "App";
  const handleMenuClick = ({ key }) => {
    return;
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="profile" onClick={() => navigate("/profile")}>
        Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );
  useEffect(() => {
    const handleResize = () => setIsMobileScreen(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const breadcrumbNameMap = {
    // "/dashboard": "Dashboard",
    "/bank-dashboard": "Bank Dashboard",
    "/bank-dashboard/bank-details": "Dashboard",
    // "/agency": "Agency Details",
    // "/agency/user": "User",
    // "/agency/product": "Product",
    // "/agency/area-codes": "Area Codes",
    "/portfolio": "Portfolio",
    // "/permission": "Rules",
    "/rules": "Rules",
    "/allocate": "Allocation",
    "/allocate/cases": "Cases",
    "/geo-tagging": "GEO Tagging",
    "/upload": "Upload",
    "/target-achievement": "Target & Achievement",
    "/analysis/overview": "Overview",
    "/analysis/coverage": "Coverage",
    "/analysis/productivity": "Productivity",
    "/analysis/performance": "Performance",
    "/collecteaze-ai": "Collecteaze Chat AI",
    // "/communication": "Connect",
    "/communication/sms": "SMS",
    "/communication/whatsapp": "Whatsapp",
    "/communication/email": "Email",
  };

  const pathSnippets = location.pathname.split("/").filter((i) => i);

  const breadcrumbItems = pathSnippets.map((snippet, idx) => {
    const url = `/${pathSnippets.slice(0, idx + 1).join("/")}`;
    const name =
      breadcrumbNameMap[url] ||
      snippet.charAt(0).toUpperCase() + snippet.slice(1);

    const isClickable = breadcrumbNameMap.hasOwnProperty(url);

    const decodedName = decodeURIComponent(name);

    const content =
      decodedName.length > 26 ? (
        <Tooltip color="black" title={decodedName}>
          <span>{decodedName.slice(0, 26) + "..."}</span>
        </Tooltip>
      ) : (
        <span>{decodedName}</span>
      );

    return {
      title: isClickable ? <Link to={url}>{content}</Link> : content,
    };
  });

  useEffect(() => {
    if (!collapsed) {
      const handleClickOutside = (event) => {
        const sider = document.querySelector(".slider_main");
        if (sider && !sider.contains(event.target)) {
          setCollapsed(true);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [collapsed]);

  const isLeafMenuItem = (key, items = menuItems) => {
    for (const item of items) {
      if (item.key === key) {
        return !item.children;
      }
      if (item.children) {
        const found = isLeafMenuItem(key, item.children);
        if (found) return true;
      }
    }
    return false;
  };

  return (
    <ConfigProvider>
      <Card className="main_card" variant="borderless">
        <Layout style={{ minHeight: "100vh" }} className="wrapper_layoutMain">
          {!isMobile ? (
            <Sider
              collapsible
              collapsed={collapsed}
              onCollapse={setCollapsed}
              width={250}
              collapsedWidth={80}
              className="slider_main"
            >
              <div
                className="sidebar-logo"
                style={{ display: "flex", alignItems: "center" }}
              >
                {collapsed ? (
                  <img src={logo} alt="App Logo" className="sidebar-logo-img" />
                ) : (
                  <img
                    src={fullLogo}
                    alt="Full Logo"
                    className="sidebar-logo-img"
                  />
                )}
              </div>
              <ConfigProvider
                theme={{
                  token: {
                    padding: 20,
                  },
                  components: {
                    Menu: {
                      itemHeight: 37,
                      itemBorderRadius: 8,
                      itemColor: "rgba(0, 0, 0, 0.88)",
                      itemHoverColor: "#f2654a",
                      itemSelectedColor: "#f2654a",
                      itemSelectedBg: "#fff4f2", // light tint of primary
                      itemHoverBg: "#fff4f2",
                      iconSize: 18,
                      itemMarginBlock: 8,
                    },
                  },
                }}
              >
                <Menu
                  mode="inline"
                  theme="light"
                  selectedKeys={[selectedKey]}
                  openKeys={openKeys}
                  onOpenChange={handleOpenChange}
                  defaultOpenKeys={openKey}
                  onClick={({ key }) => {
                    const item = menuItems.find((i) => i.key === key);
                    if (item && item.children) {
                      handleSubMenuClick(key);
                    }
                  }}
                  className="menu_list"
                  items={menuItems}
                  style={{ padding: "0 20px" }}
                  tooltipProps={collapsed ? { open: false } : undefined}
                />
              </ConfigProvider>
            </Sider>
          ) : (
            <Drawer
              title="Navigation"
              placement="left"
              onClose={() => setDrawerOpen(false)}
              open={drawerOpen}
              width={200}
              className="drawer_section"
            >
              <Menu
                mode="inline"
                theme="light"
                selectedKeys={[selectedKey]}
                openKeys={openKeys}
                onOpenChange={handleOpenChange}
                defaultOpenKeys={openKey}
                onClick={({ key }) => {
                  if (!isLeafMenuItem(key)) {
                    handleSubMenuClick(key);
                  } else {
                    setDrawerOpen(false); // Close Drawer after navigation
                  }
                }}
                className="menu_list drawer_sidebar"
                items={menuItems}
                tooltipProps={collapsed ? { open: false } : undefined}
              />
            </Drawer>
          )}

          <Layout className="wrapper_layout" style={{ width: "100%" }}>
            <Header
              style={{
                padding: 0,
                background: "#fff",
                paddingLeft: 16,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "70px",
              }}
              className="header_main"
            >
              <Flex align="center" gap="middle">
                {isMobile && (
                  <Button
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setDrawerOpen(true)}
                  />
                )}
                <Breadcrumb
                  items={breadcrumbItems}
                  separator={<SeparatorIcon />}
                  className="customBreadcrumb"
                  style={{ fontWeight: 500 }}
                />
              </Flex>
              <Flex style={{ width: "80%" }} justify="end" align="center">
                {isMobileScreen ? (
                  <Dropdown
                    menu={{
                      items: formatPriceKeys.map((item) => ({
                        key: item.value,
                        label: (
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {item.label}
                            {format === item.value && (
                              <CheckOutlined
                                style={{ color: "#007fff", marginLeft: 8 }}
                              />
                            )}
                          </span>
                        ),
                        onClick: () => dispatch(setPriceFormat(item.value)),
                      })),
                    }}
                    trigger={["click"]}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <Space style={{ display: "flex", alignItems: "center" }}>
                        <CashIcon
                          style={{
                            width: 20,
                            height: 20,
                            display: "flex",
                            alignItems: "center",
                          }}
                        />
                        <DownOutlined />
                      </Space>
                    </a>
                  </Dropdown>
                ) : (
                  <Tabs
                    options={formatPriceKeys}
                    active={format}
                    onChange={(val) => dispatch(setPriceFormat(val))}
                    // selectorBreakpoint={900}
                    showSelector={false}
                  />
                )}
              </Flex>

              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Flex align="center" gap="small" className="avtarBox">
                  <Text style={{ textWrap: "nowrap" }} className="avatarName">
                    Hi,{" "}
                    {user?.first_name?.length > 8 ? (
                      <Tooltip title={user.first_name}>
                        {user.first_name.slice(0, 8)}...
                      </Tooltip>
                    ) : (
                      user?.first_name
                    )}
                  </Text>
                  <Avatar
                    size={30}
                    style={{ minWidth: 30, minHeight: 30 }}
                    icon={<UserOutlined />}
                  />
                </Flex>
              </Dropdown>
            </Header>

            <Content style={{ margin: "0 16px" }} className="content_main">
              <div className="contentWrapper">{children}</div>
              <Toaster position="top-center" reverseOrder={false} />
            </Content>
          </Layout>
        </Layout>
      </Card>
    </ConfigProvider>
  );
};

export default PageLayout;
